import AService from '@/services/AService';

const ENTITY_NAME = 'sites';

export default class SiteService extends AService {

  async create(site){
    const response = await this.http.post(`${this.baseUrl}/${ENTITY_NAME}`, site)
    return response.data;
  }

  async fetchSitesPagingAndSorting(params) {
    const response = await this.http.get(`${this.baseUrl}/${ENTITY_NAME}/pagingAndSorting`, {params})
    return response.data;
  }

  async fetchById(id) {
    const response = await this.http.get(`${this.baseUrl}/${ENTITY_NAME}/${id}`);
    return response.data;
  }

  async update(site){
    const response = await this.http.put(`${this.baseUrl}/${ENTITY_NAME}`, site)
    return response.data;
  }

  async updateStatus(site, value) {
    const response = await this.http.patch(`${this.baseUrl}/${ENTITY_NAME}/${site.id}/status?enabled=${value}`);
    return response.data;
  }

  async deleteSite(site) {
    const response = await this.http.delete(`${this.baseUrl}/${ENTITY_NAME}/${site.id}`)
    return response.data;
  }
}
